export const LOADING_LEVEL_EMPLOYEE = "LOADING_LEVEL_EMPLOYEE";
export const SAVE_LOADING_LEVEL_EMPLOYEE = "SAVE_LOADING_LEVEL_EMPLOYEE";
export const GET_LEVEL_EMPLOYEE = "GET_LEVEL_EMPLOYEE";
export const FORM_FAIL = "FORM_FAIL";
export const LEVEL_EMPLOYEE_FAIL = "LEVEL_EMPLOYEE_FAIL";
export const LOADING_LEVEL_EMPLOYEE_BY_ID = "LOADING_LEVEL_EMPLOYEE_BY_ID";
export const GET_LEVEL_EMPLOYEE_BY_ID = "GET_LEVEL_EMPLOYEE_BY_ID";

